/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function navigateBack(options, context) {
    context === null || context === void 0 ? void 0 : context.PanguMiniAppCall('navigateBack', options);
}

export { navigateBack as default };
